/**
 * @module utils
 * @package @geenius/adapters/react-shadcn
 * @description Small shadcn-compatible class name helper used by the bridge
 * components without depending on unpublished UI package internals.
 */

import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

/** Merges conditional classes with Tailwind conflict resolution. */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
